import moment from "moment";
import type {ISoru, IYarisma, IYarismaciCevap, IYarismaKalansure} from "./yarisma";

export interface IYarismaDTO {
  i: string;
  d?: string;
  bm?: string;
  sa?: boolean;
  sam?: boolean;
  ss?: number;
  s?: number;
}

export function mapYarismaFromDTO(dto: IYarismaDTO): IYarisma {
  return {
    isim: dto.i,
    detay: dto.d,
    bitis_metni: dto.bm,
    sonuc_aciklandi_mi: dto.sa ?? false,
    siralama_aciklandi_mi: dto.sam ?? false,
    soru_sayisi: dto.ss ?? 0,
    sure: dto.s ?? 0
  };
}

export interface IYarismaKalansureDTO {
  bt: string;
  bsk: number;
  btk: number;
  yb: boolean;
}

export function mapYarismaKalansureFromDTO(dto: IYarismaKalansureDTO): IYarismaKalansure {
  return {
    baslangic_tarihi: moment(dto.bt).format("DD-MM-YYYY"),
    baslangic_saati: moment(dto.bt).format("HH:mm"),
    baslamasina_kalan_sure: dto.bsk,
    bitmesine_kalan_sure: dto.btk,
    yarismaci_bitirmis_mi: dto.yb,
  };
}

export interface ISoruDTO {
  i: number;
  ru?: string;
  m?: string;
  yc?: number;
  s: ISoruSecenekDTO[];
  dc?: number;
  p: number;
  hm?: boolean;
  ha?: string;
  hdc?: number[];
}

export interface ISoruSecenekDTO {
  i: number;
  m: string;
}

export function mapSoruFromDTO(dto: ISoruDTO[]): ISoru[] {
  return dto.map<ISoru>((dto: ISoruDTO) => {
    return {
      id: dto.i,
      resim_url: dto.ru,
      metin: dto.m,
      yarismaci_cevap: dto.yc,
      secenekler: dto.s?.map((secenek: ISoruSecenekDTO) => ({
        index: secenek.i,
        metin: secenek.m
      })),
      dogru_cevap: dto.dc,
      puan: dto.p,
      hatali_mi: dto.hm,
      hata_aciklamasi: dto.ha,
      hata_dogru_cevaplar: dto.hdc
    };
  });
}


export interface IYarismaciCevapDTO {
  sid: number;
  cei: number;
  ct?: Date;
}

export function mapYarismaciCevapToDTO(ycm: IYarismaciCevap): IYarismaciCevapDTO {
  return {
    sid: ycm.soru_id,
    cei: ycm.cevap_index,
    ct: ycm.client_time
  };
}
